import { slideDown, slideUp, toggleClass } from './common';

const WRAPPER_SELECTOR = '.e-div--vertical-dropdown-wrapper';
const SECTION_SELECTOR = '.e-div';
const HEADER_SELECTOR = '.wp-block-heading';
const PANEL_SELECTOR = '.facetwp-facet';
const ACTIVE_CLASS = 'is-active';
const INTEGRATIONS_SECTION_SELECTOR = '.e-stn--integrations-listing';

const findHeader = ( section ) =>
  section.querySelector( HEADER_SELECTOR ) || null;

const findPanelAfterHeader = ( section, header ) => {
  let el = header?.nextElementSibling || null;
  while ( el && !el.matches( PANEL_SELECTOR ) ) el = el.nextElementSibling;
  return el || null;
};

const preserveCurrentState = ( section, panel ) => {
  const visible = panel && window.getComputedStyle( panel ).display !== 'none';
  if ( visible ) section.classList.add( ACTIVE_CLASS );
};

const bindHeaderClick = ( section, header, panel ) => {
  if ( !header || !panel ) return;
  if ( header.dataset.bound === '1' ) return;
  header.dataset.bound = '1';

  header.addEventListener( 'click', () => {
    const isActive = section.classList.contains( ACTIVE_CLASS );
    toggleClass( section, ACTIVE_CLASS );
    if ( isActive ) slideUp( panel );
    else slideDown( panel );
  } );
};

const initSection = ( section ) => {
  if ( !section ) return;
  if ( section.closest( INTEGRATIONS_SECTION_SELECTOR ) ) return;

  const header = findHeader( section );
  if ( !header ) return;

  const panel = findPanelAfterHeader( section, header );
  if ( !panel ) return;

  preserveCurrentState( section, panel );
  bindHeaderClick( section, header, panel );
};

const initAccordion = ( root = document ) => {
  const wrappers = root.querySelectorAll( WRAPPER_SELECTOR );
  if ( !wrappers.length ) return;
  wrappers.forEach( ( wrapper ) =>
    wrapper.querySelectorAll( SECTION_SELECTOR ).forEach( initSection )
  );
};

/* ================================================================
    MOBILE FILTER TOGGLE (CLASS ONLY)
   ================================================================ */

const FILTER_WRAPPER = '.e-div--vertical-filter';
const DROPDOWN_WRAPPER = '.e-div--vertical-dropdown-wrapper';
const SEARCH_WRAPPER_SELECTOR = '.e-div--search-wrapper';
const HAMBURGER_CLASS = 'mobile-filter-toggle';
const CLOSE_BTN_CLASS = 'mobile-filter-close';
const PANEL_HOST_CLASS = 'mobile-filter-panel-host';

const OPEN_CLASS = 'is-open'; // for dropdown
const BODY_OPEN_CLASS = 'filter-open'; // for body

const createHamburger = () => {
  const btn = document.createElement( 'button' );
  btn.className = HAMBURGER_CLASS;
  btn.innerHTML = '';
  btn.setAttribute( 'aria-label', 'Open Filters' );
  return btn;
};

const createCloseButton = () => {
  const btn = document.createElement( 'button' );
  btn.className = CLOSE_BTN_CLASS;
  btn.innerHTML = '';
  btn.setAttribute( 'aria-label', 'Close Filters' );
  return btn;
};

const bindMobilePanel = ( container, dropdown ) => {
  if ( !container || !dropdown ) return;
  container.classList.add( PANEL_HOST_CLASS );

  if ( !container.querySelector( `.${HAMBURGER_CLASS}` ) ) {
    const hamburger = createHamburger();
    container.insertBefore( hamburger, container.firstChild );
    hamburger.setAttribute( 'aria-expanded', 'false' );

    hamburger.addEventListener( 'click', ( e ) => {
      e.stopPropagation();
      dropdown.classList.add( OPEN_CLASS );
      document.body.classList.add( BODY_OPEN_CLASS );
      hamburger.setAttribute( 'aria-expanded', 'true' );
    } );
  }

  if ( !dropdown.querySelector( `.${CLOSE_BTN_CLASS}` ) ) {
    const closeBtn = createCloseButton();
    dropdown.insertBefore( closeBtn, dropdown.firstChild );

    closeBtn.addEventListener( 'click', ( e ) => {
      e.stopPropagation();
      dropdown.classList.remove( OPEN_CLASS );
      document.body.classList.remove( BODY_OPEN_CLASS );
      const hamburger = container.querySelector( `.${HAMBURGER_CLASS}` );
      if ( hamburger ) hamburger.setAttribute( 'aria-expanded', 'false' );
    } );
  }

  if ( dropdown.dataset.outsideBound !== '1' ) {
    dropdown.dataset.outsideBound = '1';
    document.addEventListener( 'click', ( e ) => {
      if ( dropdown.contains( e.target ) ) return;
      dropdown.classList.remove( OPEN_CLASS );
      document.body.classList.remove( BODY_OPEN_CLASS );
      const hamburger = container.querySelector( `.${HAMBURGER_CLASS}` );
      if ( hamburger ) hamburger.setAttribute( 'aria-expanded', 'false' );
    } );
  }
};

const initMobileToggle = ( root = document ) => {
  const filters = root.querySelectorAll( FILTER_WRAPPER );
  if ( !filters.length ) return;
  filters.forEach( ( filter ) => {
    bindMobilePanel( filter, filter.querySelector( DROPDOWN_WRAPPER ) );
  } );
};

const initIntegrationsMobileToggle = ( root = document ) => {
  const sections = root.querySelectorAll( INTEGRATIONS_SECTION_SELECTOR );
  if ( !sections.length ) return;

  sections.forEach( ( section ) => {
    const dropdown = section.querySelector( DROPDOWN_WRAPPER );
    if ( !dropdown ) return;
    const container = section.querySelector( SEARCH_WRAPPER_SELECTOR ) || dropdown.parentElement || section;
    bindMobilePanel( container, dropdown );
  } );
};

/* ================================================================
    BOOT & FACET RELOAD
   ================================================================ */

const facetFilterAccordion = () => {
  document.addEventListener( 'DOMContentLoaded', () => {
    initAccordion();
    initMobileToggle();
    initIntegrationsMobileToggle();
  } );

  document.addEventListener( 'facetwp-loaded', () => {
    initAccordion();
    initMobileToggle();
    initIntegrationsMobileToggle();
  } );
};

facetFilterAccordion();
